<div class="compact-card">
    @if (device.type !== DeviceType3D.STOREY) {
        <div class="img-container">
            <img [src]="'/assets/img/overview_grid/' + (device.panelType ? device.panelType : 'HOME') + '.png'" />
        </div>
        <div class="column info" [class.extended]="!this.showBattery()">
            <web-device-type-label class="body-medium" [type]="device.panelType" [surname]="device.name" />
            <div class="row">
                <div class="column device-info">
                    @if (device.state === DeviceState.CONNECTED) {
                        <ng-container>
                            <div class="header body-medium grey">{{ 'GLOBAL.PRODUCTION' | translate }}</div>
                            <web-fading-span
                                valueClass="sub-headline-bold short-line-height"
                                suffixClass="sub-headline-bold short-line-height"
                                [value]="device.production ? device.production : '-'"
                                [suffix]="device.production ? 'W' : ''"
                            ></web-fading-span
                        ></ng-container>
                    } @else {
                        <div>
                            <div class="header body-medium grey">{{ 'GLOBAL.STATUS' | translate }}</div>
                            <web-fading-span
                                class="sub-headline-regular small-line-height"
                                prefixImg="solar-lost-connection.svg"
                                value="{{ 'PAGES.OVERVIEW.LOST_CONNECTION' | translate }}"
                                valueClass="white flex"
                                imgClass="red flex"
                            ></web-fading-span>
                        </div>
                    }
                </div>
                @if (this.showBattery()) {
                    <ng-container>
                        <hr class="vertical" />

                        <web-batterie-icon
                            *ngIf="device.batteryState"
                            [batterieState]="device.batteryState"
                        ></web-batterie-icon>

                        <web-energy-info
                            [label]="'GLOBAL.BATTERY' | translate"
                            [value]="device.battery"
                            color="grey"
                            suffix="%"
                            valueClass="sub-headline-bold short-line-height"
                            suffixClass="sub-headline-bold short-line-height"
                        >
                        </web-energy-info>
                    </ng-container>
                }
            </div>
        </div>
    } @else {
        <div class="img-container">
            <img src="/assets/img/overview_grid/STOREY.png" />
        </div>
        <div class="column info">
            <web-device-type-label class="body-medium" [type]="DeviceTypeEnum.STOREY" [surname]="device.name" />
            <div class="row">
                @if (device.batteryState === BatteryState.INITIALIZING) {
                    <div>
                        <div class="header body-medium grey">{{ 'GLOBAL.STATUS' | translate }}</div>
                        <div class="initialize-container">
                            <ion-icon
                                class="loader"
                                slot="icon-only"
                                src="assets/icon/loader.svg"
                                color="light"
                            ></ion-icon>
                            <web-fading-span
                                class="sub-headline-regular small-line-height"
                                value="{{ 'GLOBAL.BATTERY_STATE.INITIALIZING' | translate }}"
                                valueClass="white flex"
                                suffixClass="wrap"
                            ></web-fading-span>
                        </div>
                    </div>
                } @else if (device.batteryState === BatteryState.DEVICE_OFF) {
                    <div>
                        <div class="header body-medium grey">{{ 'GLOBAL.STATUS' | translate }}</div>
                        <web-fading-span
                            class="sub-headline-regular small-line-height"
                            prefixImg="storey-lost-connection.svg"
                            value="{{ 'PAGES.OVERVIEW.LOST_CONNECTION' | translate }}"
                            valueClass="white flex"
                            imgClass="red flex"
                        ></web-fading-span>
                    </div>
                } @else {
                    @if (isBatteryPaused()) {
                        <div class="column">
                            <div class="header body-medium grey">
                                {{ 'GLOBAL.STATUS' | translate }}
                            </div>
                            <div class="row info">
                                <ion-icon
                                    class="loader"
                                    slot="icon-only"
                                    src="assets/icon/loader.svg"
                                    color="light"
                                ></ion-icon>
                                <div>
                                    <span> {{ 'PAGES.OVERVIEW.STOREY.PAUSE_UNTIL' | translate }} </span>
                                    <span>
                                        {{
                                            getStoreyInhibitionDate().toLocaleTimeString([], {
                                                hour: '2-digit',
                                                minute: '2-digit',
                                            })
                                        }}
                                    </span>
                                    <sup class="yellow">{{ getDaysDiffToDisplay() }}</sup>
                                </div>
                            </div>
                        </div>
                    } @else {
                        @if (device.batteryState) {
                            <web-batterie-icon [batterieState]="device.batteryState"></web-batterie-icon>
                        }
                        <div class="column">
                            <div class="header body-medium grey">
                                {{ 'GLOBAL.AVAILABLE' | translate }}
                            </div>
                            <div class="row info">
                                <web-fading-span
                                    [value]="device.soc ? device.soc : '-'"
                                    [suffix]="device.soc ? '%' : ''"
                                ></web-fading-span>
                                <hr class="vertical" />
                                <web-fading-span
                                    [value]="device.storedEnergyKwh ? device.storedEnergyKwh : '-'"
                                    [suffix]="device.storedEnergyKwh ? 'Wh' : '-'"
                                ></web-fading-span>
                            </div>
                        </div>
                    }
                }
            </div>
        </div>
    }
</div>
